import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { FaGlassMartini, FaCog } from 'react-icons/fa';
// import {
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Form,
//   FormGroup,
//   Input,
//   Label
// } from "reactstrap";
import '../styles/feeding.css';


export const Feeding = class Form extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    // this.getUserData();
  }

  render() {
    return (
      <div className="col-sm-12 col-md-12 col-xs-12" style={{padding: "0px",height: "100%",overflowY: "scroll",overflowX: "hidden"}}>
        <body id="food">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 col-sm-12 col-xs-12" style={{padding: "0px"}}>
                <div style={{height: "60vh",margin: "0px"}} id="food_btn">
                  <div  style={{height: "50%"}}>
                    <Link to={`${process.env.PUBLIC_URL}/dashboard/feeding/feeding-practice/`}><button className="form-control" style={{height: "100%"}}><span style={{fontSize: "3em",color:"hsl(120, 50%, 40%)"}}><FaGlassMartini/></span><br/>LISHE YA {this.props.Child.first_name}</button></Link>
                  </div>
                  <div style={{height: "50%"}}>
                    <Link to={`${process.env.PUBLIC_URL}/dashboard/feeding/smart-feeding/`}><button className="form-control" style={{height: "100%"}}><span style={{fontSize: "3em",color:"hsl(120, 50%, 40%)"}}><FaCog/></span><br/>LISHE MAKINI</button></Link>
                  </div>	
                </div>
              </div>	
            </div>
          </div>	
        </body>
      </div>
    );
  }
}

export default Feeding;